import React from 'react'
import { Button, withStyles } from '@material-ui/core'
import classNames from 'classnames'

import { colors } from 'theme'
import Link from './Link'

/**
 * Super Summary button component
 * Variants:
 *  default: theme button
 *  primary1 and primary2: primary color variations
 *  secondary: brand color button
 *  ghost: transparent button
 *  lighter: lighter than secondary color button
 */
const SSButton = ({ variant, children, className, classes, to, ...props }) => {
  const btnClass = classNames(classes.button, classes[variant], className)
  const muiVariant = variant === 'ghost' ? 'outlined' : 'contained'
  const component = to ? Link : undefined

  return (
    <Button
      className={btnClass}
      variant={muiVariant}
      color="primary"
      component={component}
      to={to}
      {...props}
    >
      {children}
    </Button>
  )
}

const styles = () => ({
  button: {
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  primary1: {
    background: colors.yellowNeutral,
    color: colors.gray900,
    '&:hover': {
      background: colors.yellowDark,
    },
  },
  primary2: {
    background: colors.lavenderDark,
    color: colors.white,
  },
  secondary: {
    background: colors.brandAqua,
    color: colors.white,
  },
  lightAqua: {
    fontSize: 14,
    background: colors.aqua500,
    color: colors.white,
    borderRadius: 8,
  },
  ghost: {
    background: colors.transparent,
    color: colors.brandAqua,
    borderRadius: 5,
    border: `1px solid ${colors.brandAqua}`,
    '&:hover': {
      color: colors.aqua800,
      borderColor: colors.aqua800,
    },
  },
  // TODO this is out of the design system
  lighter: {
    background: colors.maximumBlueGreen,
    color: colors.white,
  },
})

export default withStyles(styles)(SSButton)
